import { Component, computed, inject, Input, signal } from '@angular/core';
import {
    FrameworkColumn,
    IEntity,
    ITableCellValueRenderer,
} from '@pf/shared-common';
import { WmsPlatformEntity } from '@control-tower/platform-wms';
import { SourceEntityService } from '../services/source-entity.service';

@Component({
    selector: 'platform-source-entity-cell-renderer',
    template: `
        @if (sourceEntityInfo(); as info) {
            @if (info.identifier) {
                <strong>{{ info.identifier }}</strong>
            }
            <span>{{ info.label }}</span>
        }
    `,
    styles: [
        `
            :host {
                display: flex;
                flex-direction: column;
            }
        `,
    ],
    standalone: false,
})
export class SourceEntityCellRendererComponent
    implements ITableCellValueRenderer
{
    private readonly sourceEntityService = inject(SourceEntityService);
    sourceEntity = signal<WmsPlatformEntity | null>(null);
    source = signal<IEntity | null>(null);
    sourceEntityInfo = computed(() => {
        if (!this.sourceEntity() || !this.source()) {
            return null;
        }

        return this.sourceEntityService.getSourceInfo(
            this.sourceEntity() as WmsPlatformEntity,
            this.source()
        );
    });

    @Input() set value(sourceEntity: WmsPlatformEntity | undefined | null) {
        this.sourceEntity.set(sourceEntity || null);
    }

    @Input() column!: FrameworkColumn;
    @Input() set row(record: { source: IEntity } | undefined | null) {
        this.source.set(record?.source || null);
    }
}
